import { memo } from 'react';

import { Box, Typography } from '@mui/material';

import { NoResultsIcon } from './icons/NoResults';

interface EmptySearchResultsProps {
  strings: Record<'noSearchResultsTitle' | 'noSearchResultsSubtitle', string>;
}

export const EmptySearchResults = memo(function EmptySearchResults({
  strings,
}: EmptySearchResultsProps) {
  return (
    <Box>
      <Box display="flex" flexDirection="column" alignItems="center" m="auto">
        <Box mb={2}>
          <NoResultsIcon />
        </Box>
        <Box mb={1}>
          <Typography variant="subtitleM">{strings.noSearchResultsTitle}</Typography>
        </Box>
        <Box>
          <Typography variant="bodyM">{strings.noSearchResultsSubtitle}</Typography>
        </Box>
      </Box>
    </Box>
  );
});
